import { gql } from "generated-graphql";

export const WASTE_INVOICES_QUERY = gql(`
  query WasteInvoicesTable(
    $tenantId: ID!
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    wasteInvoices(
      tenantId: $tenantId
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
    ) {
      count
      items {
        id
        vendor {
          id
          name
        }
        invoiceNumber
        invoiceDate
        invoiceTotal
        servicePeriodStart
        servicePeriodEnd
        lineCount
        createdAt
      }
    }
  }
`);

export const WASTE_INVOICE_DETAIL_QUERY = gql(`
  query WasteInvoiceDetail($id: ID!) {
    wasteInvoice(id: $id) {
      id
      tenantId
      vendor {
        id
        name
      }
      invoiceNumber
      invoiceDate
      invoiceTotal
      servicePeriodStart
      servicePeriodEnd
      lineCount
      sourceDocument {
        id
      }
      createdAt
      updatedAt
    }
  }
`);

export const GET_WASTE_INVOICE_DOCUMENT_DOWNLOAD_URL = gql(`
  query GetWasteInvoiceDocumentDownloadUrl($id: ID!) {
    getWasteInvoiceDocumentDownloadUrl(id: $id)
  }
`);

export const WASTE_INVOICE_LINES_QUERY = gql(`
  query WasteInvoiceLinesTable(
    $invoiceId: ID!
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    wasteInvoiceLines(
      invoiceId: $invoiceId
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
    ) {
      count
      items {
        id
        kind
        description
        facility {
          id
          name
        }
        billingQuantity
        billingUnit
        unitPrice
        billedAmount
        shippingDocumentNumber
        serviceDate
        serviceOrderNumber
        matchedProcessedManifest {
          id
          manifestTrackingNumber
        }
      }
    }
  }
`);

export const QUEUE_WASTE_INVOICE_IMPORT = gql(`
  mutation QueueWasteInvoiceImport($input: QueueWasteInvoiceImportInput!) {
    queueWasteInvoiceImport(input: $input) {
      id
      status
      vendor
      sourceDocument {
        id
        title
        fileExtension
      }
      createdAt
      updatedAt
    }
  }
`);

export const WASTE_INVOICE_IMPORT_RUN_QUERY = gql(`
  query WasteInvoiceImportRun($id: ID!) {
    wasteInvoiceImportRun(id: $id) {
      id
      tenantId
      vendor
      status
      sourceDocument {
        id
        title
        fileExtension
      }
      summary {
        sourceRowCount
        invoiceCount
        lineCount
        totalBilledAmount
        createdCount
        noOpCount
        completedAt
      }
      failure {
        code
        message
        issues {
          code
          message
          invoiceNumber
          sourceRowNumber
          field
        }
      }
      createdAt
      updatedAt
    }
  }
`);
